import React, { FC, useCallback, useEffect, useState } from 'react';
import { CashieringTable } from './components/CashieringTable';
import { CashieringFilters } from './components/CashieringFilters';
import { useStateSelector } from '../../../data/global/dataSelectors';
import { Loading } from '@tradingblock/components';
import { useLatestPendingCashieringDate } from '../../../hooks/useLatestPendingCashieringDate';
import { useDispatch } from 'react-redux';
import { AdminCashieringActions } from '../../../data/global/actions/admin/AdminCashieringActions';
import { getCashieringSearchFilterData } from '../../../data/global/selectors/admin/cashieringSelectors';

const CASHIERING_TABLE_DATE_COLUMN = 'Date';

const CashieringHeader: FC<{}> = () => {
  const dispatch = useDispatch();

  const [newPendingRequestsExist, setNewPendingRequestsExist] = useState(false);
  const handleNewCashieringRequests = useCallback(() => setNewPendingRequestsExist(true), []);
  useLatestPendingCashieringDate(handleNewCashieringRequests, true);

  const refreshCashieringData = useCallback(() => {
    setNewPendingRequestsExist(false);
    dispatch(
      AdminCashieringActions.refresh({ sortBy: CASHIERING_TABLE_DATE_COLUMN, sortByOrder: 'desc', replace: true })
    );
  }, []);

  return (
    <>
      <h3 style={{ display: 'inline', margin: '0 var(--gap) calc(var(--gap) / 2) 0' }}>Cashiering review</h3>

      {newPendingRequestsExist && (
        <span style={{ display: 'inline-block' }}>
          {'New requests have been received. '}
          <a href="#" onClick={refreshCashieringData}>
            Refresh list
          </a>
          {' to see them. '}
        </span>
      )}
    </>
  );
};

export const AdminCashieringIndex = () => {
  const [selectedRowIndex, setSelectedRowIndex] = React.useState<number | undefined>(undefined);

  const handleSetSelectedRowIndex = useCallback((index: number | undefined) => {
    setSelectedRowIndex(index);
  }, []);

  return (
    <div className="screen-body-section">
      <CashieringHeader />
      <CashieringFilters handleSetSelectedRow={handleSetSelectedRowIndex} />
      <CashieringTable handleSetSelectedRow={handleSetSelectedRowIndex} selectedRowIndex={selectedRowIndex} />
    </div>
  );
};
